<template>
  <div v-if="inputErrors" class="error-messages">
    <ul>
      <li v-for="(inerr, index) in inputErrors" :key="index">
        {{ inerr.message }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  computed: {
    inputErrors() {
      return this.$store.state.incidentReport.inputErrors;
    },
  },
};
</script>

<style lang="scss">
.error-messages {
  color: red;
  font-size: small;
}
</style>
